import axios from 'axios'
import store from '../vuex/store'

const client = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000
})

// Add a request interceptor
client.interceptors.request.use(function (config) {
  if (store.state.token) {
    config.headers = {
      Authorization: `Bearer ${store.state.token}}`
    }
  }
  // Do something before request is sent
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
client.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    window.location.href = '#/login'
  }

  return Promise.reject(error)
})

export default client
